import { IoMdSettings } from "react-icons/io";
import { AiFillShopping } from "react-icons/ai";
import { MdEdit } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
export function SettingSideBarItems(localization, commonUtils) {
  return [
    {
      category: localization.organizationSetting,
      key: "Organization",
      items: [
        {
          lable: localization.userManagement,
          path: "/setting/masterpage",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin(),
        },
        {
          lable: localization.plant,
          path: "/setting/plant/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin(),
        },
        {
          lable: localization.headerName,
          path: "/setting/building/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin(),
        },
        {
          lable: localization.costCenter,
          path: "/setting/costCenter/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin(),
        },
        {
          lable: localization.costCenterGroup,
          path: "/setting/CostCenterGroup/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin(),
        },
        {
          lable: localization.manufacturer,
          path: "/setting/herstellerList/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin()
              ? true
              : false,
        },
        {
          lable: localization.manageTicket,
          path: "/setting/ManageTicket/",
          show: commonUtils.hasManageTicketPermission(),
        },
        {
          lable: localization.advancedSetting,
          path: "/setting/organizationSetting/",
          show: commonUtils.isUserOrganisationAdmin() ? true : false,
        },
      ],
      icon: <AiFillShopping className="svgIcon listHeadingIcon" />,
    },
    {
      category: localization.inspectionSetting,
      key: "Inspection",
      items: [
        {
          lable: localization.pruefGroup,
          path: "/setting/pruefGroup/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin()
              ? true
              : false,
        },
        {
          lable: localization.digitalChecklist,
          path: "/setting/digitalChecklist/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin() ||
            commonUtils.isAdmin()
              ? true
              : false,
        },
        {
          lable: localization.feedBack,
          path: "/setting/feedBack/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin(),
        },
        {
          lable: localization.inspectionReports,
          path: "/setting/inspectionReports/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin() ||
            commonUtils.isAdmin()
              ? true
              : false,
        },
      ],
      icon: <MdEdit className="svgIcon listHeadingIcon" />,
    },
    {
      category: localization.equipmentSetting,
      key: "Equipment",
      items: [
        {
          lable: localization.equipmentGroup,
          path: "/setting/equipmentgroup/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin() ||
            commonUtils.isAdmin()
              ? true
              : false,
        },
        {
          lable: localization.nameOfEquipment,
          path: "/setting/bezeichnungList/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin()
              ? true
              : false,
        },
        {
          lable: localization.standardAttribute,
          path: "/setting/standardAttributeList/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin(),
        },
        {
          lable: localization.equipScrappedDataHed,
          path: "/setting/scrappedEquipments/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin(),
        },
      ],
      icon: <FaLocationDot className="svgIcon listHeadingIcon" />,
    },
    {
      key: "General",
      category: localization.generalSetting,
      items: [
        {
          lable: localization.import,
          path: "/setting/import/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin() ||
            commonUtils.isAdmin(),
        },
        {
          lable: localization.exportTitle,
          path: "/setting/export/",
          show: commonUtils.isUserOrganisationAdmin(),
        },

        {
          lable: localization.emailNotification,
          path: "/setting/emailList/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin(),
        },
        {
          lable: localization.configValidation,
          path: "/setting/configValidation/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin(),
        },
        {
          lable: localization.audit,
          path: "/setting/audit/",
          show:
            commonUtils.isUserOrganisationAdmin() ||
            commonUtils.isUserWerkAdmin(),
        },
      ],
      icon: <IoMdSettings className="svgIcon listHeadingIcon" />,
    },
  ];
}
